import { render, staticRenderFns } from "./VerificationData.vue?vue&type=template&id=dedb72ca&scoped=true&lang=pug&"
import script from "./VerificationData.vue?vue&type=script&lang=js&"
export * from "./VerificationData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationData.vue?vue&type=style&index=0&id=dedb72ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedb72ca",
  null
  
)

export default component.exports